import { gql } from '@apollo/client/index.js'
import { useSafeContentfulWithFallback } from '@ecomm/shared-apollo'
import { DEFAULT_LEAD_SOURCES } from './constants'
import { foundSimpliSafeThroughSchema } from './foundSimpliSafeThroughSchema'

const FALLBACK_VALUE = {
  title: 'I found SimpliSafe through',
  placeholder: 'Please select one...',
  options: DEFAULT_LEAD_SOURCES
}

export const FOUND_SIMPLISAFE_THROUGH_QUERY = gql`
query foundSimpliSafeThroughQuery($locale: String!, $preview: Boolean!) {
  foundThroughDropdown: input(
    id: "6EEb97GvnZZY4OlFBqlr27"
    locale: $locale
    preview: $preview
  ) {
    title
    placeholder
    options
  }
}`

export function useFoundSimpliSafeThroughQuery() {
  const result = useSafeContentfulWithFallback(
    FOUND_SIMPLISAFE_THROUGH_QUERY,
    'foundThroughDropdown',
    foundSimpliSafeThroughSchema,
    FALLBACK_VALUE
  )

  return result
}
